import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"
import type { Tag } from "@/types"

/**
 * A single tag rendered as a pill badge.
 */
export function TagBadge({ tag }: { tag: Tag }) {
  return (
    <Badge size="sm" color="brand" type="pill-color">
      {tag.name}
    </Badge>
  )
}

/**
 * A group of tag badges.
 * @param tags - The tags to render.
 * @param variant - `wrap` flows onto multiple lines; `row` keeps a single horizontally-scrollable line.
 * @returns The TagBadgeGroup component.
 */
export function TagBadgeGroup({
  tags,
  variant = "wrap",
}: {
  tags: Tag[]
  variant?: "wrap" | "row"
}) {
  if (!Array.isArray(tags) || tags.length === 0) return null

  const styledVariants = {
    wrap: "flex-wrap",
    row: "min-w-0 flex-nowrap overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
  }

  return (
    <div className={cn("flex gap-2 py-1", styledVariants[variant])}>
      {tags.map((tag) => (
        <TagBadge key={tag.slug || tag.id} tag={tag} />
      ))}
    </div>
  )
}
